<template>
  <div class="actions-collapsed-list">
    <a
      class="btn btn-function exit-collapsed-list"
      @click.prevent="$emit('activate', currentNumber.id)"
    >
      <i
        v-tooltip.right.hover="$t('CANCEL')"
        class="glyphicon glyphicon-chevron-left"
        aria-hidden="true"
      />
    </a>

    <div class="action-icon">
      <a
        :disabled="!canEdit"
        :href="getHref('dashboard.numbers.edit', { numberId: currentNumber.id })"
        class="btn btn-list-function"
        @click.prevent="$emit('on-edit', currentNumber)"
      >
        <i
          v-tooltip.right.hover="$t('NUMBERS_ACTIONS_EDIT')"
          class="typcn typcn-edit"
          aria-hidden="true"
        />
        <span
          v-t="'NUMBERS_ACTIONS_EDIT'"
          class="hint-text-mobile"
        />
      </a>
    </div>

    <div class="action-icon">
      <a
        href="javascript:;"
        class="btn btn-list-function"
        :disabled="!canDelete"
        @click="$emit('on-delete', currentNumber)"
      >
        <i
          v-tooltip.right.hover="$t('NUMBERS_DEALLOCATE')"
          class="typcn typcn-trash"
        />
        <span
          v-t="'NUMBERS_DEALLOCATE'"
          class="hint-text-mobile"
        />
      </a>
    </div>

    <div
      v-if="pauseAvailable"
      class="action-icon"
    >
      <a
        :disabled="!canPause"
        class="btn btn-list-function"
        @click="$emit('on-pause', currentNumber)"
      >
        <i
          v-tooltip.left.hover="$t('NUMBERS_ACTIONS_PAUSE')"
          class="typcn typcn-media-pause"
          aria-hidden="true"
        />
        <span
          v-t="'PAUSE'"
          class="hint-text-mobile"
        />
      </a>
    </div>

    <div
      v-if="enableAvailable"
      class="action-icon"
    >
      <a
        class="btn btn-list-function"
        @click="$emit('on-enable', currentNumber)"
      >
        <i
          v-tooltip.left.hover="$t('NUMBERS_ACTIONS_ENABLE')"
          class="typcn typcn-media-play"
          aria-hidden="true"
        />
        <span
          v-t="'ENABLE'"
          class="hint-text-mobile"
        />
      </a>
    </div>

    <ChangeLogObjectButtonAction
      :is-disabled="disabled"
      :object-id="currentNumber.id"
      :object-name="currentNumber.phoneNumber"
      object-type="number"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import sharedMessages from '@/core/locales';
import messages from '../../locales';
import {
  $ngStateService,
} from '@/angularBridgeCode/ringbaPortal.servicesModule';

import ChangeLogObjectButtonAction from '@/core/components/ChangeLog/ChangeLogObjectButtonAction.vue';

export default defineComponent({
  components: {
    ChangeLogObjectButtonAction,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
    canPause: {
      type: Boolean,
      default: false,
    },
    pauseAvailable: {
      type: Boolean,
      default: false,
    },
    enableAvailable: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: ''
    },
    currentNumber: {
      type: Object,
      required: true,
    },
  },
  emits: [
    'activate',
    'on-edit',
    'on-delete',
    'on-pause',
    'on-enable',
  ],
  methods: {
    getHref(state, params) {
      return $ngStateService.href(
        state,
        params,
        { absolute: true }
      );
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
});
</script>
